import Button from '../Button/Button'
import { GitHubIcon, LinkedInIcon, MailIcon, TwitterIcon } from '../Icon/Icon'
import { social } from '../../../data/portfolio'
import styles from './SocialLinks.module.css'

const LINKS = [
  { key: 'github', label: 'GitHub', href: social.github, Icon: GitHubIcon },
  { key: 'linkedin', label: 'LinkedIn', href: social.linkedin, Icon: LinkedInIcon },
  { key: 'twitter', label: 'X (Twitter)', href: social.twitter, Icon: TwitterIcon },
  {
    key: 'email',
    label: 'Email',
    href: social.email ? `mailto:${social.email}` : '',
    Icon: MailIcon,
  },
].filter((link) => Boolean(link.href))

const SocialLinks = ({ size = 'md', className = '' }) => {
  if (!LINKS.length) return null

  return (
    <ul className={`${styles.list} ${className}`.trim()}>
      {LINKS.map(({ key, label, href, Icon }) => (
        <li key={key}>
          <Button
            href={href}
            variant="icon"
            size={size}
            aria-label={label}
            title={label}
          >
            <Icon size={18} />
          </Button>
        </li>
      ))}
    </ul>
  )
}

export default SocialLinks
